<template>
  <div class="root">
    <div class="header-box add-bg">
      <div class="c-header">
        <div class="header-logo">
          <a href="/">
            <img src="./images/header-logo-orange-xd.png">
          </a>
        </div>
        <!-- <div class="credit">
        <a href="javascript:;" @click.prevent="showQrcode">征信查询</a>
        <div class="qrcode-box">
          <i class="close-btn" @click="closeQrcode"></i>
          <div class="qrcode-content">
            <p>风险信用不可小觑</p>
            <p>您有一份征信报告待查看</p>
            <div class="qrcode" id="qrcode" ref="qrcode"></div>
            <div class="foot">扫码即刻查征信</div>
          </div>
        </div>
      </div> -->
        <ul class="nav">
          <li v-for="(item,index) in navList" :key="index">
            <a @click="goUrl(item.url)" :class="{ active:index==currentPage}">{{item.name}}</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="content">
      <a href="/#/joinUs">返回职位列表</a>
      <div v-if="JSON.stringify(jobDetail) === '{}'"></div>
      <div v-else class="job-detail">
        <h2>{{jobDetail.positionName}}</h2>
        <ul>
          <li>{{jobDetail.positionType}} | {{jobDetail.workPlace}}</li>
          <li>{{jobDetail.department}}</li>
          <li>{{jobDetail.positionName}}</li>
        </ul>
        <div class="describe" v-html="jobDetail.content"></div>
        <p>简历投递邮箱:<span>jrzp@bajiegroup.com</span></p>
        <div class="more">
          <a href="/#/joinUsMain">查看更多</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import job from "@/global/js/staticData/job";
import $ from "jquery";
import QRCode from "qrcodejs2";
export default {
  name: "joinus-detail",
  data() {
    return {
      navList: [
        {
          name: "联系我们",
          url: "/contactUs",
        },
        {
          name: "加入我们",
          url: "/joinUsMain",
        },
        {
          name: "公司公告",
          url: "/announcementList",
        },
        {
          name: "场景服务",
          url: "/sceneService",
        },
        {
          name: "关于八戒小贷",
          url: "/aboutUs",
        },
        {
          name: "首页",
          url: "/index",
        },
      ],
      currentPage: 1,
      jobList: [], // 模拟职位招聘信息
      jobDetail: {},
      positionName: "",
    };
  },
  mounted() {
    this.$bus.$emit("ready");
    this.jobList = job.jobList;
    this.positionName = this.$route.query.name || "";
    this.jobList.forEach((item) => {
      if (item.positionName === this.positionName) {
        this.jobDetail = item;
      }
    });
  },
  methods: {
    goUrl(url) {
      this.$router.push(url);
    },
    showQrcode() {
      $(".qrcode").html("");
      let qrcode = new QRCode("qrcode", {
        width: 154, // 设置宽度
        height: 154, // 设置高度
        text: "https://m.tianxiaxinyong.cn/cooperation/crp-v2/per-detail.html?channel=K3lRa1Z6WE9aY2Iveng0VHNoN2d3Zz09",
      });
      $(".qrcode-box").slideDown(300, "linear", function () {
        $(".qrcode-content").fadeIn(500);
      });
    },
    closeQrcode() {
      $(".qrcode-box").fadeOut();
      $(".qrcode-content").hide();
    },
  },
};
</script>
<style lang="less">
@import "..\..\..\global\css\mixin\mixin.less";
.el-pager li.active {
  color: #ff6900;
  border: 1px solid #ff6900;
  border-radius: 20px;
}
.el-pager li:hover {
  color: #ff6900;
}
.el-pager li {
  min-width: 28.5px;
}
.el-pagination .btn-next,
.el-pagination .btn-prev {
  &:hover {
    color: #ff6900;
  }
}
</style>
<style scoped rel="stylesheet/less" lang="less">
@import "..\..\..\global\css\mixin\mixin.less";
.root {
  background-color: transparent;
}
.header-box {
  width: 100%;
  height: 104px;
  position: fixed;
  left: 0px;
  top: 0px;
  z-index: 999;
  &.add-bg {
    background: url("./images/white-header-bg.png") no-repeat top center;
  }
}
.c-header {
  background-color: #fff;
  font-size: 22px;
  width: 1200px;
  height: 80px;
  line-height: 80px;
  // overflow: hidden;
  position: fixed;
  top: 0;
  left: 50%;
  margin-left: -600px;
  z-index: 999;
  background-color: transparent;
  .header-logo {
    float: left;
    width: 105px;
    height: 80px;
    text-align: center;
    position: relative;
    img {
      width: 166px;
      vertical-align: middle;
      // position: relative;
      // bottom: 3px;
    }
  }
  .credit {
    float: right;
    width: 124px;
    height: 80px;
    text-align: center;
    position: relative;
    margin-left: 55px;
    font-size: 16px;
    a {
      position: absolute;
      width: 124px;
      height: 40px;
      line-height: 40px;
      left: 0;
      top: 20px;
      color: #fff;
      background: url("./images/credit.png") no-repeat;
    }
    .qrcode-box {
      display: none;
      position: absolute;
      width: 264px;
      height: 447px;
      top: 60px;
      left: -70px;
      box-sizing: border-box;
      padding: 137px 36px 26px 36px;
      background: url("./images/qrcode-box.png") no-repeat;
      .close-btn {
        position: absolute;
        width: 20px;
        height: 20px;
        top: 145px;
        right: 40px;
        background: url("./images/qrcode-close.png") no-repeat;
        cursor: pointer;
      }
      .qrcode-content {
        width: 160px;
        height: 260px;
        padding: 24px 16px 0px 16px;
        display: none;
        p {
          height: 20px;
          line-height: 20px;
          color: #000000;
          font-size: 12px;
        }
        .qrcode {
          width: 154px;
          height: 154px;
          padding: 4px;
          border: 2px solid #ffc39c;
          margin-top: 5px;
        }
        .foot {
          width: 155px;
          height: 38px;
          margin: 0 auto;
          line-height: 38px;
          text-align: center;
          background: url("./images/qrcode-line.png") no-repeat center;
          color: #000000;
          font-size: 12px;
        }
      }
    }
  }
  .nav {
    li {
      float: right;
      cursor: pointer;
      margin-left: 55px;
      height: 80px;
      a {
        color: #666;
        font-size: 16px;
        padding: 5px 0;
        &:hover {
          color: #333333;
          border-bottom: 2px solid #ff4300;
        }
        &.active {
          color: #333333;
          border-bottom: 2px solid #ff4300;
        }
      }
    }
  }
}
.content {
  width: 1200px;
  height: auto;
  padding-top: 144px;
  margin: 0 auto;
  padding-bottom: 141px;
  a {
    display: inline-block;
    color: #7a757b;
    font-size: 16px;
    height: 40px;
    line-height: 40px;
    &:hover {
      color: #ff6900;
    }
  }
  .job-detail {
    box-sizing: border-box;
    padding: 40px;
    width: 1200px;
    background-color: #ffffff;
    border-radius: 10px;
    background-image: url("./images/job-detail.png");
    background-position: top 53px left;
    background-repeat: no-repeat;
    h2 {
      height: 46px;
      line-height: 46px;
      font-size: 22px;
      color: #222222;
      font-weight: normal;
    }
    ul {
      width: 100%;
      height: 60px;
      line-height: 60px;
      border-bottom: 1px dashed #eeeeee;
      li {
        float: left;
        width: 215px;
        color: #222222;
        font-size: 14px;
      }
    }
    .describe {
      padding-bottom: 50px;
    }
    p {
      font-size: 16px;
      color: #222222;
      height: 70px;
      line-height: 70px;
      span {
        color: #ff6600;
      }
    }
    .more {
      width: 100%;
      height: 40px;
      text-align: center;
      a {
        display: inline-block;
        width: 156px;
        height: 40px;
        line-height: 40px;
        color: #ffffff;
        background-color: #ff6900;
        border-radius: 20px;
        &:hover {
          background-color: #ff6600;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// joinUsDetail.vue?733db754